import { LoggedOutComponent } from './logged-out/logged-out.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { UnauthGuard } from './guards/unauth-guard.service';
import { LoginComponent } from './login/login.component';
import { InternalLoginComponent } from './internal-login/internal-login.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';

const routes: Routes = [
  { path: 'login', component: LoginComponent, canActivate: [UnauthGuard] },
  { path: 'internal-login', component: InternalLoginComponent, canActivate: [UnauthGuard]},
  { path: 'logged-out', component: LoggedOutComponent, canActivate: [UnauthGuard]},
  { path: 'forgot-password', component: ForgotPasswordComponent, canActivate: [UnauthGuard]}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuthRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/auth/auth-routing.module.ts